/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import  '../node_modules/bootstrap/js/src/collapse.js';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/toast';
import 'bootstrap/js/src/tooltip';
import 'bootstrap-touchspin';
import './lib/slick.min';
import './lib/jquery.hoverIntent.min';
import SlickSlider from './components/slick';
import PhotoSwipe from './lib/photoswipe';
import PhotoSwipeUI_Default from './lib/photoswipe-ui-default';


import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import './custom';

import Form from './components/form';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './components/block-cart';
import lazysizes from 'lazysizes'

import { updateFeatherIcons } from './helpers'


// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  const test = 270479;
  const form = new Form();
  let slickSlider = new SlickSlider();
  let topMenuEl = $('#_desktop_top_menu #top-menu');
  let topMenu = new TopMenu(topMenuEl);

  jQuery.migrateMute = true
  updateFeatherIcons()
  bindProductImageFlip()
  bindModalButtons()
  bindOpenFilterButton()
  //bindOpenFilterMobileButton({init: true})
  form.init();
  topMenu.init();

  // Desktop & Mobile Product page slider init
  slickSlider.init() 
  $(window).on('load resize orientationchange', function() {
    // Init again when window has changer
    slickSlider.init()
  })

  //display input file content in custom file input BS
  $('.custom-file-input').on('change',function(){
      let fileName = $(this).val().split('\\').pop();
      $(this).next('.custom-file-label').addClass("selected").html(fileName);
  })

  // make icon update accessible from modules
  prestashop.on('updateFeatherIcons', () => {
    updateFeatherIcons()
  });

  // Amazzing filters
  // Triggered after ajax product list update
  if ($('#_desktop_amazzing-filter').length) {
    customThemeActions.updateContentAfter = () => {
      updateFeatherIcons()
      bindOpenFilterButton()
      bindModalButtons()
      bindProductImageFlip()
    };
  }

  // COMPONENTS

  // Show/Hide Modals
  function bindModalButtons() {
    // HOW TO USE MODALS
    // add class="dfmodal-open-button" to the open button
    // add data-target="#your-modal-id" to the open button
    // add id="your-modal-id" to the modal
    // add a close button inside the modal
    // add class="dfmodal-close-button" to the close button
    $('.dfmodal-open-button').on('click touch', function(e) {
      const modalId = $(this).attr('data-target')
      const modal = $(modalId)
      modal.addClass('dfmodal--open');
      $('html').addClass('noscroll');
    })
    $('.dfmodal-close-button').on('click touch', function(e) {
      const modal = $(this).parents('.dfmodal')
      modal.removeClass('dfmodal--open');
      $('html').removeClass('noscroll');
    })
  }

  // close mobile menu when opening the search modal
  $('#mobile-search-button').on('click touch', function(e) {
    $('#mobile-menu').removeClass('dfmodal--open');
  })


  // HOME PAGE

  // header visibility
  if ($('.header--homepage').length) {
    let headerTopLimit = 100;
    let headerVisible = ($(window).scrollTop() > headerTopLimit);
    let header = $('.header--homepage .header-content')
    if (headerVisible) {
      // hide header if page starts already scrolled
      header.css('display', 'none')
    }
    // listen to scroll and update visibility
    $(window).scroll(function (event) {
      let scroll = $(window).scrollTop();
      if (headerVisible && scroll > headerTopLimit) {
        header.fadeOut()
        headerVisible = false
      } else if (!headerVisible && scroll < headerTopLimit) {
        header.fadeIn()
        headerVisible = true
      } 
    });
  }

  // home header color swich on menu 
  


  // PRODUCT LIST PAGE

  // Declare Open/close filters Button behavior
  function bindOpenFilterButton() {
    const filters = $('#_desktop_amazzing-filter')
    const filtersContent = $('#amazzing_filter')
    const filterButton = $('#filter-products__button')
    let isVisible = (filters.css('display') !== 'none')
    //filtersContent.css('opacity', isVisible ? 1 : 0)
    filterButton.addClass(isVisible ? 'active' : '')

    // unbind all event in case
    filterButton.off()
    // bind click event
    filterButton.click(function() {
      isVisible = !isVisible
      filterButton.toggleClass('active')
      filters.slideToggle() 
      //filtersContent.css('opacity', isVisible ? 1 : 0)
    })
  }

  // Product image flip
  // Show image number 2 on mouse hover
  function bindProductImageFlip() {
    let duration = 250
    let easing = 'swing'
    if ($('.product-thumbnail').length) {
      $('.thumbnail-1').hover(function() {
        if ($(this).next().hasClass('thumbnail-2')) {
          $(this).fadeOut(duration, easing)
          $(this).next().fadeIn(duration, easing)
        }
      })
      $('.thumbnail-2').mouseout(function() {
        $(this).fadeOut(duration, easing)
        $(this).prev().fadeIn(duration, easing)
      })
    }
  }

  // PRODUCT PAGE

  // Product Tabs
  if ($('#product-tabs').length) {
    $('.tab-title').click(function() {
      let tab = $(this).parents('.tab')
      tab.toggleClass('opened')
      $(this).parent().find('.tab-content').slideToggle(200)
    })
  }

  // Photoswipe - Mobile ZOOMED Product Page slider
  const items = []
  const items_id = []
  console.log($('.photoswipe-item'))
  $('.photoswipe-item').each(function() {
    
    if (items_id.indexOf($(this).attr('data-id'))) {
      console.log($(this).attr('data-src'));
      items_id.push($(this).attr('data-id'))
      items.push({
        src: $(this).attr('data-src'),
        w: $(this).attr('data-width') * 1,
        h: $(this).attr('data-width') * 1.4,
      })
    }
  })

  $('.images-container').on('click touch', function(e) {
    const pswpElement = document.querySelectorAll('.pswp')[0]
    const options = {
      index: parseInt($(this).attr('data-index'), 10),
      showAnimationDuration: 0,
      hideAnimationDuration: 0,
      bgOpacity: .8,
      closeOnScroll: false,
      history: false,
      getDoubleTapZoom: function(isMouseClick, item) {
        if(isMouseClick) {
          return 2;
        } else {
          return item.initialZoomLevel < 0.7 ? 1 : 1.5;
        }
      },
      // UI
      mainClass: 'pswp--minimal--dark',
      barsSize: {top:0,bottom:0},
      captionEl: false,
      fullscreenEl: false,
      zoomEl: false,
      counterEl: false,
      shareEl: false,
      bgOpacity: 0.85,
      tapToClose: true,
      tapToToggleControls: false,
    }
    const gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options)
    gallery.init()
  })



  // FEATURED PRODUCTS SLIDERS

  $('.featured-products-slider').slick({
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    touchThreshold: 8,
    speed: 200,
    waitForAnimate: false,
    responsive: [{

      breakpoint: 768,
      settings: {
        infinite: false,
        slidesToShow: 1.5,
        slidesToScroll: 1,
      }

    }]
  }); 

  // MOBILE MENU

  // Show/Hide the menu links on each category item
  $('.mainmenu-mobile__item-link').click(function(event) {
    const links = $(this).parent().find('.mainmenu-mobile__links')
    if (links.length) {
      event.preventDefault()
      links.slideToggle(100)
    }
  })

  // MOBILE FILTERS

  // close all subfilters
  $('#mobile-filters .af_filter').each(function() {
    $(this).addClass('closed')
  })




});
document.addEventListener('lazyloaded', function(e){
    $(e.target).parent().addClass('rc--lazyload');
});


// AXEPTIO

$('#show-axeptio-button').click(function(event) {
  showAxeptioButton(); // only shows the button
  openAxeptioCookies(); // show the modal
})
